// La geographie : cartes ASCII, arenes, interieurs, portails, narration et verrous de zone.
// Extrait de KubeWorld.jsx au lot A (2026-09-08) : le code n'a pas ete modifie.

// ═══ MAPS ═══
// Tile legend: M=metal C=console c=cable r=railing g=grass p=path b=bridge R=rock v=vine
// P=pillar K=crystal Q=rune H=lava N=neon A=arch I=iron G=gate J=torch
import { isWalk } from '../base.js';

const MAPS={
  hub:[
    "MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MmmMMMMMMMmmmmmmmmmcmmmmmmmmmMMMMMMMmmmM",
    "MmmMmmmmmMmmmmmmmmmcmmmmmmmmmMmmmmmMmmmM",
    "MmmMmmCmmMmmmmCmmmmmmmmmCmmmmMmmCmmMmmmM",
    "MmmMmmmmmMmmmmmmmmmcmmmmmmmmmMmmmmmMmmmM",
    "MmmMmmmmmMmmmmmmmmmcmmmmmmmmmMmmmmmMmmmM",
    "MmmMMMmMMMmmmmmmmmmcmmmmmmmmmMMMmMMMmmmM",
    "MmmmmmmmmmmmmrrrrrmmmrrrrrmmmmmmmmmmmmmM",
    "Mmmmmmmmmmmmmr=========rmmmmmmmmmmmmmmmM",
    "Mmmmmmmmmmmmmr=========rmmmmmmmmmmmmmmmM",
    "ccccccccccccc===========cccccccccccccccc",
    "Mmmmmmmmmmmmmr=========rmmmmmmmmmmmmmmmM",
    "Mmmmmmmmmmmmmr=========rmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmrrrrrmmmrrrrrmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmcmmmmmmmmmmmmmmmmmmmM",
    "MmmmMMMMMMmmmmmmmmmcmmmmmmmmmMMMMMMmmmmM",
    "MmmmMmmmmMmmmmmmmmmcmmmmmmmmmMmmmmMmmmmM",
    "MmmmMmCmmMmmmmCmmmmmmmmmCmmmmMmmCmMmmmmM",
    "MmmmMmmmmMmmmmmmmmmcmmmmmmmmmMmmmmMmmmmM",
    "MmmmMMmMMMmmmmmmmmmcmmmmmmmmmMMMmMMmmmmM",
    "MmmmmmmmmmmmmmmmmmmcmmmmmmmmmmmmmmmmmmmM",
    "MmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmmM",
    "MMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMMM"
  ],
  pods:[
    "VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV",
    "V,,,,TT,,,,,,,,,,,,,,,,,,,,,,,,TT,,,,,,V",
    "V,,,TT,,,,,ppppppppppppppp,,,,,,TT,,,,,V",
    "V,,,,,,,,,,p,,,,,,,,,,,,,p,,,,,,,,,,,,,V",
    "V,,,SS,,,,,p,,,,,,,,,,,,,p,,,,,SS,,,,,,V",
    "V,,,,,,,,,,p,,,,,,,,,,,,,p,,,,,,,,,,,,,V",
    "V,,pppppppppp,,,,,,,,,,,,pppppppppp,,,,V",
    "V,,p,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,ppppp,,,ppppp,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,p,,,p,,,p,,,p,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,p,,,,,,,,,,p,,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,p,,,p,,,p,,,p,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,ppppp,,,ppppp,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,p,,,,V",
    "V,,p,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,p,,,,V",
    "V,,pppppppppppppp,,,,,pppppppppppppppp,V",
    "V,,,,,,,,,,,,,,,p,,,,,p,,,,,,,,,,,,,,,,V",
    "V,,,TT,,,,,,,,,,p,,,,,p,,,,,,,,,,TT,,,,V",
    "V,,,,,,,,,,,,,,,ppppppp,,,,,,,,,,,,,,,,V",
    "V,,SS,,,,,,,,,,,,,,,,,,,,,,,,,,,,SS,,,,V",
    "V,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,V",
    "VVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV"
  ],
  workloads:[
    "IIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII",
    "IJeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeJI",
    "IeeIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIeeI",
    "IeeIeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeIeeI",
    "IeeIeeeeeeeeeJeeeeeeeeeeeeJeeeeeeeeeIeeI",
    "IeeIeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeIeeI",
    "IeeIeeeIIIIIIIIIIIeeeIIIIIIIIIIIeeeeIeeI",
    "IeeIeeeIeeeeeeeeeIeeeIeeeeeeeeeIeeeeIeeI",
    "IeeIeeeIeeeeeeeeeIeeeIeeeeeeeeeIeeeeIeeI",
    "IeeIeeeIeeeeeeeeeGeeeGeeeeeeeeeIeeeeIeeI",
    "IeeIeeeIeeeeeeeeeIeeeIeeeeeeeeeIeeeeIeeI",
    "IeeeeeeIeeeeeeeeeIeeeIeeeeeeeeeIeeeeeeeI",
    "IeeIeeeIeeeeeeeeeIeeeIeeeeeeeeeIeeeeIeeI",
    "IeeIeeeIIIIIIIGIIIeeeIIIGIIIIIIIeeeeIeeI",
    "IeeIeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeIeeI",
    "IeeIeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeIeeI",
    "IeeIeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeIeeI",
    "IeeIeeeeeeeeeJeeeeeeeeeeeeJeeeeeeeeeIeeI",
    "IeeIeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeIeeI",
    "IeeIIIIIIIIIIIIIIIGIIIIIIIIIIIIIIIIIIeeI",
    "IeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeI",
    "IJeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeJI",
    "IeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeI",
    "IIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIIII"
  ],
  network:[
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN",
    "N~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~N",
    "N~~nnnnnnn~~~~~~~nnnnnnnnn~~~~~~nnnnnn~N",
    "N~~nnnnnnn~~~~~~~nnnnnnnnn~~~~~~nnnnnn~N",
    "N~~nnnnnnn~~~~~~~nnnnnnnnn~~~~~~nnnnnn~N",
    "N~~nnnnnbnnnnnnnnnnnnnnnnnnnnnnbnnnnnn~N",
    "N~~nnnnnbn~~~~~~~nnnnnnnnn~~~~~bnnnnnn~N",
    "N~~~~~~~b~~~~~~~~nnnnnnnnn~~~~~b~~~~~~~N",
    "N~~~~~~~b~~~~~~~~nnnnnnnnn~~~~~b~~~~~~~N",
    "NnnnnnnnbbbbbbbbbnnnnnnnnnbbbbbbnnnnnnnN",
    "NnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnnN",
    "NnnnnnnnnbbbbbbbbbnnnnnnnnnbbbbbbnnnnnnN",
    "N~~~~~~~b~~~~~~~~nnnnnnnnn~~~~~b~~~~~~~N",
    "N~~~~~~~b~~~~~~~~nnnnnnnnn~~~~~b~~~~~~~N",
    "N~~nnnnnbn~~~~~~~nnnnnnnnn~~~~~bnnnnnn~N",
    "N~~nnnnnbnnnnnnnnnnnnnnnnnnnnnnbnnnnnn~N",
    "N~~nnnnnnn~~~~~~~nnnnnnnnn~~~~~~nnnnnn~N",
    "N~~nnnnnnn~~~~~~~nnnnnnnnn~~~~~~nnnnnn~N",
    "N~~nnnnnnn~~~~~~~nnnnnnnnn~~~~~~nnnnnn~N",
    "N~~~~~~~~~~~~~~~~nnnnnnnnn~~~~~~~~~~~~~N",
    "N~~~~~~~~~~~~~~~~nnnnnnnnn~~~~~~~~~~~~~N",
    "N~~~~~~~~~~~~~~~~nnnnnnnnn~~~~~~~~~~~~~N",
    "N~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~N",
    "NNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNNN"
  ],
  sanctum:[
    "PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP",
    "PKaaaaQaaaaaaaaaaaaaaaaaaaaaaaaaaQaaaaKP",
    "PaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaP",
    "PaaaPPPPPPPPPPPPPPPaaaPPPPPPPPPPPPPPaaaP",
    "PaaaPaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaPaaaP",
    "PaaaPaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaPaaaP",
    "PaaaPaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaPaaaP",
    "PaaaPaaaaPPPPPPPPPaaaPPPPPPPPPaaaaaPaaaP",
    "PaaaPaaaaPaaaaaaaaaaaaaaaaaaaPaaaaaPaaaP",
    "PaaaPaaaaPaaaaaaaaKaaaaaaaaaaPaaaaaPaaaP",
    "PaaaQaaaaPaaaaaaaaaaaaaaaaaaaPaaaaaQaaaP",
    "PaaaaaaaaaaaaaaaaaaKaaaaaaaaaaaaaaaaaaaP",
    "PaaaQaaaaPaaaaaaaaaaaaaaaaaaaPaaaaaQaaaP",
    "PaaaPaaaaPaaaaaaaaKaaaaaaaaaaPaaaaaPaaaP",
    "PaaaPaaaaPaaaaaaaaaaaaaaaaaaaPaaaaaPaaaP",
    "PaaaPaaaaPPPPPPPPPaaaPPPPPPPPPaaaaaPaaaP",
    "PaaaPaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaPaaaP",
    "PaaaPaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaPaaaP",
    "PaaaPaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaPaaaP",
    "PaaaPPPPPPPPPPPPPPPaaaPPPPPPPPPPPPPPaaaP",
    "PaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaP",
    "PKaaaaQaaaaaaaaaaaaaaaaaaaaaaaaaaQaaaaKP",
    "PaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaP",
    "PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP"
  ],
};

// ═══ BOSS ARENAS ═══
const BOSS_ARENAS={
  crash_lord:[
    "HHHHHHHHHHHHHHHHHH",
    "H,,,,,,,,,,,,,,,,H",
    "H,,H,,,,,,,,,,H,,H",
    "H,,,,,,,,,,,,,,,,H",
    "H,,,,,,L,,L,,,,,,H",
    "H,,,,,,,,,,,,,,,,H",
    "H,,H,,,,,,,,,,H,,H",
    "H,,,,,,,,,,,,,,,,H",
    "H,,,,,,L,,L,,,,,,H",
    "H,,,,,,,,,,,,,,,,H",
    "H,,H,,,,,,,,,,H,,H",
    "H,,,,,,,,,,,,,,,,H",
    "HHHHHHHHHHHHHHHHHH",
  ],
  rollout_reaper:[
    "IIIIIIIIIIIIIIIIII",
    "I,,,,,,,,,,,,,,,,I",
    "I,,J,,,,,,,,,,J,,I",
    "I,,,,,,,,,,,,,,,,I",
    "I,,,,cc,,,,cc,,,,I",
    "I,,,,cc,,,,cc,,,,I",
    "I,,,,,,,,,,,,,,,,I",
    "I,,,,cc,,,,cc,,,,I",
    "I,,,,cc,,,,cc,,,,I",
    "I,,,,,,,,,,,,,,,,I",
    "I,,J,,,,,,,,,,J,,I",
    "I,,,,,,,,,,,,,,,,I",
    "IIIIIIIIIIIIIIIIII",
  ],
  phantom_404:[
    "NNNNNNNNNNNNNNNNNN",
    "N,,,,,,,,,,,,,,,,N",
    "N,,N,,,,~~~~,,N,,N",
    "N,,,,,,~~~~~~,,,,N",
    "N,,,,,,~~~~~~,,,,N",
    "N,,,,,,,,~~~~,,,,N",
    "N,,,,,,,,,,,,,,,,N",
    "N,,,,,,~~~~,,,,,,N",
    "N,,,,~~~~~~,,,,,,N",
    "N,,,,~~~~~~,,,,,,N",
    "N,,N,,~~~~,,,,N,,N",
    "N,,,,,,,,,,,,,,,,N",
    "NNNNNNNNNNNNNNNNNN",
  ],
  etcd_corruptor:[
    "PPPPPPPPPPPPPPPPPP",
    "P,,,,,,,,,,,,,,,,P",
    "P,,K,,Q,,,,Q,,K,,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,Q,,,,KK,,,,Q,,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,Q,,,,KK,,,,Q,,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,K,,Q,,,,Q,,K,,P",
    "P,,,,,,,,,,,,,,,,P",
    "PPPPPPPPPPPPPPPPPP",
  ],
};

// Interior maps per zone theme
const INTERIOR_MAPS={
  hub:[ // Control room: metal walls, consoles, cables
    "MMMMMMMMMMMMMMMMM",
    "M,,,C,,,L,,,C,,,M",
    "M,,,,,,,,,,,,,,,M",
    "M,C,,,,,,,,,,,C,M",
    "M,,,,,,,,,,,,,,,M",
    "M,,,C,,,L,,,C,,,M",
    "M,,,,,,,,,,,,,,,M",
    "MMMMMMMMD,MMMMMMM",
  ],
  pods:[ // Cozy wooden cottage: grass floor, lanterns
    "gggggggggggggggggg",
    "g,,,,S,,,L,,,S,,,g",
    "g,,,,,,,,,,,,,,,,g",
    "g,,S,,,,,,,,,,S,,g",
    "g,,,,,,,,,,,,,,,,g",
    "g,,,,,,,,,,,,,,,,g",
    "g,,,,,,,,,,,,,,,,g",
    "gggggggggD,ggggggg",
  ],
  workloads:[ // Stone fortress: torches, iron
    "IIIIIIIIIIIIIIIIII",
    "I,,J,,,,L,,,,,,J,I",
    "I,,,,,,,,,,,,,,,,I",
    "I,,,,,,,,,,,,,,,,I",
    "I,,,,,,,,,,,,,,,,I",
    "I,,J,,,,L,,,,,,J,I",
    "I,,,,,,,,,,,,,,,,I",
    "IIIIIIIIID,IIIIIII",
  ],
  network:[ // Cyber lab: neon walls, water feature
    "NNNNNNNNNNNNNNNNNN",
    "N,,N,,,,L,,,,,,N,N",
    "N,,,,,,,,,,,,,,,,N",
    "N,,,,~~,,,,~~,,,,N",
    "N,,,,~~,,,,~~,,,,N",
    "N,,,,,,,,,,,,,,,,N",
    "N,,N,,,,L,,,,,,N,N",
    "NNNNNNNND,NNNNNNNN",
  ],
  sanctum:[ // Arcane temple: crystals, runes, pillars
    "PPPPPPPPPPPPPPPPPP",
    "P,,K,,Q,,L,,Q,,K,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,Q,,,,,,,,,,Q,,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,,,,,,,,,,,,,,,P",
    "P,,K,,Q,,L,,Q,,K,P",
    "PPPPPPPPPD,PPPPPPP",
  ],
};
const INTERIOR_MAP=INTERIOR_MAPS.hub; // fallback

// ═══ PORTALS (coordinate-based, NOT tile-based) ═══
const PORTALS={
  hub:[
    {x:0,y:11,to:'pods',sx:19,sy:21,label:'🏘️ Pod Village'},
    {x:39,y:11,to:'workloads',sx:17,sy:21,label:'🏰 Workloads'},
    {x:19,y:1,to:'network',sx:21,sy:20,label:'🌐 Network'},
    {x:19,y:22,to:'sanctum',sx:17,sy:21,label:'🔮 Sanctum'},
  ],
  pods:[{x:19,y:22,to:'hub',sx:1,sy:11,label:'← Hub'}],
  workloads:[{x:17,y:20,to:'hub',sx:38,sy:11,label:'← Hub'}],
  network:[{x:21,y:21,to:'hub',sx:19,sy:2,label:'← Hub'}],
  sanctum:[{x:17,y:22,to:'hub',sx:19,sy:21,label:'← Hub'}],
};

// Zone intro narratives
const ZONE_INTROS={
  hub:{title:'Cluster Hub',sub:'Centre de Contrôle',text:"Bienvenue, SRE. Le cluster est en danger.\nLes 4 Gardiens corrompus contrôlent chaque zone.\nMaîtrise Kubernetes et restaure l'ordre."},
  pods:{title:'Pod Village',sub:'Le Monde des Pods',text:"Les pods crashent en boucle ici.\nLe CrashLord terrorise le village.\nApprends les fondamentaux et vaincs-le."},
  workloads:{title:'Workload Fortress',sub:'La Forteresse des Workloads',text:"Les déploiements sont bloqués.\nLe Rollout Reaper a figé tous les rollouts.\nMaîtrise les Deployments et brise le siège."},
  network:{title:'Network Realm',sub:'Le Royaume du Réseau',text:"Un brouillard de 404 recouvre ce monde.\nLe Phantom a corrompu toutes les routes.\nComprends le réseau K8s pour le dissiper."},
  sanctum:{title:'Arcane Sanctum',sub:'Le Sanctuaire Arcanique',text:"Les données se désintègrent.\nL'etcd Corruptor dévore le key-value store.\nC'est le dernier combat. Sauve le cluster."},
};

// Each zone requires beating the PREVIOUS zone's boss to unlock (e.g. sanctum requires phantom_404 from network)
// Case de repli par zone : l'arrivee du portail qui y mene. Sert quand une sauvegarde
// pointe une case devenue infranchissable (carte redessinee depuis la derniere partie).
const ENTREES={hub:{x:18,y:12},pods:{x:19,y:21},workloads:{x:17,y:21},network:{x:21,y:20},sanctum:{x:17,y:21}};
// Combien de cases praticables par zone. C'est cette surface qui fixe combien la zone
// porte de vie : un nombre identique partout donnerait une zone deux fois plus vide
// qu'une autre pour la seule raison qu'elle est deux fois plus grande.
const SURFACES=Object.fromEntries(Object.keys(MAPS).map(z=>[z,MAPS[z].join('').split('').filter(isWalk).length]));

// ═══ INTERIEURS DE LA SECONDE MAISON DE CHAQUE ZONE ═══
// ⚠️ Les deux portes d'une zone menaient a la MEME piece : meme forme, meme mobilier,
// seuls les habitants changeaient. Une porte qui ne mene nulle part de nouveau est une
// promesse non tenue (regle R11). Chaque maison a donc maintenant sa piece, dont la
// forme et le mobilier disent a quoi elle sert (R9).
// Contraintes : 22 cases de large et 15 de haut au maximum (la camera ne defile pas a
// l'interieur), une porte 'D' sur la rangee du bas, et la case juste au-dessus libre.
const INTERIOR_MAPS_B={
  // Salle des Archives : de longues rangees de baies, une allee centrale.
  hub: [
    "MMMMMMMMMMMMMMMMMMM",
    "M,,,,,,,,,,,,,,,,,M",
    "M,CCCC,,,,,,,,CCCC,",
    "M,,,,,,,,L,,,,,,,,M",
    "M,CCCC,,,,,,,,CCCC,",
    "M,,,,,,,,,,,,,,,,,M",
    "M,CCCC,,,,,,,,CCCC,",
    "M,,,,,,,,,,,,,,,,,M",
    "MMMMMMMMMD,MMMMMMMM",
  ],
  // Labo des Images : une paillasse au centre, des plants en observation autour.
  pods: [
    "gggggggggggggggg",
    "g,,,,,,,,,,,,,,g",
    "g,S,,,,,,,,,,S,g",
    "g,,,,CCCC,,,,,,g",
    "g,,,,,,,,,,,,,,g",
    "g,,,,,,,,L,,,,,g",
    "g,S,,,,,,,,,,S,g",
    "g,,,,,,,,,,,,,,g",
    "ggggggggD,gggggg",
  ],
  // Armurerie YAML : des rateliers le long des murs, rien au milieu.
  workloads: [
    "IIIIIIIIIIIIIIIIIIII",
    "I,JJJJJJ,,,,JJJJJJ,I",
    "I,,,,,,,,,,,,,,,,,,I",
    "I,,,,,,,,,,,,,,,,,,I",
    "IJ,,,,,,,,L,,,,,,,JI",
    "I,,,,,,,,,,,,,,,,,,I",
    "I,,,,,,,,,,,,,,,,,,I",
    "I,JJJJJJ,,,,JJJJJJ,I",
    "IIIIIIIIID,IIIIIIIII",
  ],
  // Firewall Dojo : un tapis carre encercle par le vide, on entre par un pont.
  network: [
    "NNNNNNNNNNNNNNNNN",
    "N~~~~~~~~~~~~~~~N",
    "N~,,,,,,,,,,,,,~N",
    "N~,,,,,,L,,,,,,~N",
    "N~,,,,,,,,,,,,,~N",
    "N~,,,,,,,,,,,,,~N",
    "N~~~~~~,,,~~~~~~N",
    "N,,,,,,,,,,,,,,,N",
    "NNNNNNNND,NNNNNNN",
  ],
  // Salle du Conseil RBAC : une table ronde de runes, une seule entree.
  sanctum: [
    "PPPPPPPPPPPPPPPPP",
    "P,,,,,,,,,,,,,,,P",
    "P,,,QQQQQQQ,,,,,P",
    "P,,,Q,,,,,Q,,,,,P",
    "P,,,Q,,K,,Q,,,,,P",
    "P,,,Q,,,,,Q,,,,,P",
    "P,,,QQQQQQQ,,,,,P",
    "P,,,,,,,,,,,L,,,P",
    "PPPPPPPPD,PPPPPPP",
  ],
};

const ZONE_REQ={hub:{l:1,b:null},pods:{l:1,b:null},workloads:{l:3,b:'crash_lord'},network:{l:5,b:'rollout_reaper'},sanctum:{l:7,b:'phantom_404'}};

export { MAPS, BOSS_ARENAS, INTERIOR_MAPS, INTERIOR_MAPS_B, INTERIOR_MAP, PORTALS, ZONE_INTROS, ENTREES, ZONE_REQ, SURFACES };
